import { css } from 'linaria';

export const accordion = css`
  width: 100%;
`;

export const accordionPanel = css`
  &:first-child {
    border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  }

  &:last-child {
    border-bottom: 1px solid var(--control-minor);
    border-radius: 0 0 var(--rounding-l) var(--rounding-l);
  }

  &:nth-of-type(n + 1) {
    border-top: 1px solid var(--control-minor);
    border-right: 1px solid var(--control-minor);
    border-left: 1px solid var(--control-minor);

    &:hover {
      border-color: var(--control-hover-secondary);

      & + div {
        border-top-color: var(--control-hover-secondary);
      }
    }
  }
`;
